import React, { useEffect, useState } from 'react';
import { Pagination, Skeleton } from 'antd';
import { toast } from 'react-toastify';
import { FlexWrapper, PaginationBox } from '../../../theme/common_style';
import { ReportNotFoundIcon } from '../../../theme/SvgIcons';
import EmptyData from '../../../components/common/EmptyData';
import { getAllProjectReports } from '../../../services/api_collection';
import { useLocation } from 'react-router-dom';
import { getFullName } from '../../../utils/common_functions';
import { apiModules } from '../../../utils/constant';
import dayjs from 'dayjs';
import styled from '@emotion/styled';
import ReportingCard from './ReportingCard';

const ProjectReporting = () => {
  const [limit] = useState(20);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const location = useLocation();
  const { id } = location.state || {};
  const [sortedDate, setSortedDate] = useState([]);

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleGetList = async () => {
    try {
      setLoading(true);
      let params = new URLSearchParams();
      params.append('limit', limit);
      params.append('page', page);
      id && params.append('projectId', id);
      params.append('moduleType', apiModules.PROJECT);
      const res = await getAllProjectReports(params);
      if (res?.statusCode === 200) {
        let result = {};
        res?.data?.reportings?.forEach((el) => {
          if (result[el?.reporting_date]) {
            result[el?.reporting_date].push(el);
          } else {
            result[el?.reporting_date] = [el];
          }
        });
        setData(result || {});
        setSortedDate(Object?.keys(result)?.sort((a, b) => new Date(b) - new Date(a)) || []);
        setTotal(res?.data?.pagination?.total);
      } else toast.error(res?.message || 'Something went wrong');
    } catch (err) {
      toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetList();
  }, [page]);

  return (
    <div>
      {sortedDate.length > 0 || loading ? (
        loading ? (
          <FlexWrapper direction="column" gap="24px" cursor="default">
            {[1, 2, 3]?.map((_, index) => (
              <div
                key={index}
                style={{
                  width: '100%',
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  padding: '16px'
                }}>
                <Skeleton active title={false} paragraph={{ rows: 8 }} />
              </div>
            ))}
          </FlexWrapper>
        ) : (
          <FlexWrapper direction="column" gap="25px" cursor="default">
            {sortedDate?.length > 0 &&
              sortedDate?.map((el, index) => {
                return (
                  <BackgroundStyle key={index}>
                    <FlexWrapper className="time" justify="start" width="100%">
                      {dayjs(el).format('DD MMM, YYYY')}
                    </FlexWrapper>
                    {data?.[el]?.map((item, index) => {
                      return (
                        <ReportingCard
                          report={item}
                          key={index}
                          empName={getFullName(
                            item?.emp_reporting_id?.first_name,
                            item?.emp_reporting_id?.middle_name,
                            item?.emp_reporting_id?.last_name
                          )}
                          handleGetList={handleGetList}
                          showActions={false}
                        />
                      );
                    })}
                  </BackgroundStyle>
                );
              })}
          </FlexWrapper>
        )
      ) : (
        <EmptyData
          height={'70vh'}
          icon={<ReportNotFoundIcon />}
          title={'No Report'}
          subTitle={'No Report Found'}
        />
      )}
      {total > limit && (
        <PaginationBox>
          <Pagination
            current={page}
            prefixCls="custom-pagination"
            pageSize={limit}
            total={total}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </PaginationBox>
      )}
    </div>
  );
};

export default ProjectReporting;

const BackgroundStyle = styled.div`
  background: #c6c6c633;
  padding: 8px;
  border-radius: 12px;
  margin: 0 auto;
  width: 100%;
  font-family: 'Plus Jakarta Sans';
  display: flex;
  flex-direction: column;
  gap: 10px;

  .time {
    font-family: 'Plus Jakarta Sans';
    font-style: normal;
    font-weight: 900;
    font-size: 24px;
    line-height: 15px;
    color: ${({ theme }) => theme.primaryColor};
    margin: 10px 0;
  }
`;
